/**
 * Created by Administrator on 2018/7/5.
 */
export default[
  {
    path: '/payStatus',
    component: () => import('../pages/payment/payStatus'),
    children: [
      {
        path: 'finish',
        component: () => import('../pages/payment/finish')
      },
      {
        path: 'unfinish',
        component: () => import('../pages/payment/unfinish')
      }
    ]
  },
  {
    path: '/finish-detail',
    component: () => import('../pages/payment/finish-detail')
  },
  {
    path: '/payDetail',
    component: () => import('../pages/payment/payDetail')
  }
]



// WEBPACK FOOTER //
// ./src/router/payment.js